import { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Button } from '../../../global/button/Button'
import IconButton from '../../../global/iconButton/IconButton'
import { CloseWithBoundingBoxIcon } from '../../../icons/CloseWithBoundingBoxIcon'
import { TextH3 } from '../../Typography/Typography'

import styles from './ModalContentWrapper.module.scss'

interface ModalContentWrapperProps {
  title?: string
  applyLabel?: string
  cancelLabel?: string
  isApplyDisabled?: boolean
  isCancelShownOnDesktop?: boolean
  onClose?: () => void
  onConfirm?: () => void
  onCancel?: () => void
  closeText?: string
}

// TODO: should be removed, was created when we did not had "modals system".
export const ModalContentWrapper: FC<PropsWithChildren<ModalContentWrapperProps>> = (props) => {
  const { t } = useTranslation()

  const {
    title,
    children,
    applyLabel = t('Apply'),
    cancelLabel = t('Cancel'),
    isApplyDisabled,
    isCancelShownOnDesktop,
    onClose,
    onConfirm,
    onCancel,
  } = props

  return (
    <div
      className={classNames(styles.modalContentWrapper, {
        [styles.cancelShownOnDesktop]: isCancelShownOnDesktop,
      })}
    >
      <div className={styles.header}>
        <TextH3>{title}</TextH3>
        <IconButton.New
          className={styles.closeButton}
          appearance='secondary'
          size='S'
          onClick={() => onClose?.()}
        >
          <CloseWithBoundingBoxIcon />
        </IconButton.New>
      </div>
      <div>{children}</div>
      <div className={styles.footer}>
        {onCancel && (
          <Button.New
            className={styles.cancelButton}
            appearance='secondary'
            size='L'
            onClick={() => onCancel()}
          >
            {cancelLabel}
          </Button.New>
        )}
        {onConfirm && (
          <Button
            type='button'
            className={styles.applyButton}
            appearance='primary'
            size='L'
            onClick={() => onConfirm()}
            disabled={isApplyDisabled}
          >
            {applyLabel}
          </Button>
        )}
      </div>
    </div>
  )
}
